import React from 'react';
import {DesktopDatePicker, LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import calendarIcon from 'assets/icon-calendar.svg';
import T from 'i18n-react';
import 'components/UI/Input/SelectYearInput.css';

const CalendarIconSvgComponent = () => {
    return (<img src={calendarIcon} alt="Calendar"/>);
};

const SelectYearInput = (props) => {

    const {maxYear, minYear, year, setYear, form} = props;
    const minDate = dayjs(new Date(`${minYear}-01-01`));
    const maxDate = dayjs(new Date(`${maxYear}-12-31`));
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DesktopDatePicker
                views={['year']}
                minDate={minDate}
                openTo="year"
                maxDate={maxDate}
                yearsPerRow={4}
                slots={{
                    openPickerIcon: CalendarIconSvgComponent,
                }}
                slotProps={{
                    textField: {
                        inputProps: {
                            form: form,
                        },
                        placeholder: T.translate('vinQueryComponent.choose'),
                        name: 'year',
                    },
                    popper: {
                        className: 'datePickerPopper',
                        // iPad fix to set year in a calendar
                        onTouchStart: (event) => {
                            const yearValueText = event.target?.textContent;
                            if (Number.isInteger(parseInt(yearValueText))) {
                                setYear(dayjs(new Date(`${yearValueText}-01-01`)));
                            }
                        }
                    },
                    field: {
                        clearable: true,
                        onClear: () => setYear(null),
                        onKeyDown: (event) => {
                            if (event.key === 'Tab') {
                                event.stopPropagation();
                            }
                        },
                    },
                }}
                onChange={value => setYear(value)}
                value={year}
            />
        </LocalizationProvider>
    );
};

export default SelectYearInput;
